import { Component, Input, ElementRef, ViewChild, OnDestroy, Output, AfterViewInit } from '@angular/core';
import { Demographics } from '../../../classes/demographics';
import { EventEmitter } from 'events';
import { SCREEN_SIZE } from '../../../classes/enums';
import { DomManipulationService } from '../../../services/dom-manipulation/dom-manipulation.service';
import { CHART_SCRIPT } from '../../../classes/dynamicScripts';
import { truncate } from 'lodash';
import { Subscription } from 'rxjs';
import {CommunicationService} from '../../../services/communication.service';
import {HasSubscriptions} from "../../has-subscriptions";
import {Neighbourhood} from "../../../classes/neighbourhood";

@Component({
  selector: 'app-demographics-section',
  templateUrl: './demographics-section.component.html',
  styleUrls: [
    './demographics-section.component.scss'
  ],
})
export class DemographicsSectionComponent extends HasSubscriptions implements AfterViewInit, OnDestroy {

  constructor(
    private domManipulationService: DomManipulationService,
    private communicationService: CommunicationService ) {
    super();
  }

  @ViewChild('overviewTab') overviewTab: ElementRef;
  @ViewChild('neighbourhoodTab') neighbourhoodTab: ElementRef;
  @ViewChild('incomeChartTab') incomeChartTab: ElementRef;
  @ViewChild('housingTypeChartTab') housingTypeChartTab: ElementRef;
  @ViewChild('populationAgeTab') populationAgeTab: ElementRef;
  @ViewChild('tenancyTab') tenancyTab: ElementRef;
  @ViewChild('motherTongueTab') motherTongueTab: ElementRef;
  @ViewChild('commuteModeTab') commuteModeTab: ElementRef;
  @Input() demographics: Demographics;
  @Input() neighbourhood: Neighbourhood;
  @Output() ready = new EventEmitter();
  @Input() screenSize: SCREEN_SIZE;
  activeTab: ElementRef<any>;
  tenancyChartSubs: Subscription;

  SCREEN_SIZE = SCREEN_SIZE;
  reducedCharacterDesktop: string;
  reducedCharacterMobile: string;
  hasChartJsLoaded: boolean;

  ngOnInit() {
    this.addSub(this.communicationService.screenSize.subscribe((screenSize) => {
      this.screenSize = screenSize;
    }))
  }

  ngAfterViewInit(): void {
    this.tenancyChartSubs = this.domManipulationService.loadScript(CHART_SCRIPT).subscribe(() => {
      this.hasChartJsLoaded = true;
    })
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this.tenancyChartSubs) {
      this.tenancyChartSubs.unsubscribe();
    }
  }
  /*
  Reduce length of text to 'length' number of characters and append '...' at the end
   */
  reduceText(text: string, length: number) {
    return truncate(text, {
      'length': length,
      'separator': ' '
    });

  }
}
